<template>
  <div>
    <van-nav-bar :title="title" left-arrow @click-left="$router.push('/files')" />
    <van-row>
      <van-col span="24" style="color: red; font-weight: bold; text-align: center;">
        注意：逐张拍照时，请确保图片拍摄清晰！
      </van-col>
    </van-row>
    <van-progress
      v-if="uploading"
      :percentage="uploadingPercentage"
      :pivot-text="uploadingMsg"
      color="#13ce66"
    />
    <van-row>
      <van-col :span="24" style="text-align: center;">
        <br>
        <van-uploader accept="*" v-model="fileList" :max-count="99" upload-text="请选择文件"
                      :disabled="!canUpload" :deletable="canUpload" multiple :after-read="afterRead"
                      :before-delete="beforeDelete"
        />
      </van-col>
    </van-row>
  </div>
</template>

<script>
  import { uploadImages, deleteImage, getLastBatch } from '@/api/elecnotes'
  export default {
    data() {
      return {
        title: '',

        fileOrd: 1,
        fileList: [],
        uploadData: {
          is_phone: true,
          client_id: this.$store.getters.currClient.client_id,
          curr_date: this.$store.getters.currDate,
          batch: null,
          ele_id: null,
          type: null
        },
        canUpload: true,
        uploading: false,
        uploadingPercentage: 0,
        uploadingMsg: ''
      }
    },
    mounted() {
      const typeId = this.$route.params.type
      if (typeId) {
        this.uploadData.type = typeId
        this.title = this.CONST.FILE_TYPE_LIST.find(type => type.id === parseInt(typeId)).name
      }
      this.getLastBatchCode()
    },
    methods: {
      beforeDelete(file) {
        return new Promise((resolve, reject) => {
          deleteImage({
            id: file.obj.id
          }).then(resp => {
            if (resp.success) {
              resolve()
              this.$toast(resp.msg)
            } else {
              reject()
            }
          })
        })
      },
      async afterRead(file) {
        this.canUpload = false
        this.uploading = true
        this.uploadingPercentage = 0
        let files = []
        if (file instanceof Array) {
          files = file
        } else {
          files.push(file)
        }
        for (let i = 0; i < files.length; i++) {
          this.uploadingPercentage = parseFloat(parseFloat((i + 1) / files.length * 100).toFixed(2))
          this.uploadingMsg = ` ${i + 1}/${ files.length }`

          let originFile = files[i]
          let suffixPos = originFile.file.name.lastIndexOf('.')
          let suffixName = originFile.file.name.substring(suffixPos + 1)
          let isImg = this.CONST.UPLOAD.IMAGE_TYPES.find(type => type === suffixName.toLowerCase()) != null
          if (isImg) {
            let rst = await this.lrz(originFile.file)
            await this.uploadFile(originFile, rst.formData, this.fileOrd++).catch(() => {
              this.$toast.fail('文件上传失败')
            })
          } else {
            let formData = new FormData()
            formData.append('file', originFile.file)
            await this.uploadFile(originFile, formData, this.fileOrd++).catch(() => {
              this.$toast.fail('文件上传失败')
            })
          }
        }
        this.canUpload = true
        this.uploading = false
        this.uploadingPercentage = 100
      },
      uploadFile(originFile, formData, ord) {
        return new Promise((resolve, reject) => {
          for(const key in this.uploadData) {
            formData.append(key, this.uploadData[key])
          }
          formData.append('ord', ord)
          uploadImages(formData).then(resp => {
            if (resp.success) {
              if(resp.obj) {
                originFile.obj = resp.obj
                this.uploadData.ele_id = resp.obj.ele_id
              }
              console.log('文件上传成功 ord: ', ord)
              this.$toast.success(resp.msg)
              resolve()
            } else {
              console.error('文件上传失败 ord: ', ord)
              this.delFile(step, originFile)
              reject()
            }
          }).catch(() => {
            console.error('文件上传失败 ord: ', ord)
            this.delFile(step, originFile)
            reject()
          })
        })
      },
      delFile(step, file) {
        let index = step.fileList.indexOf(file)
        if (index !== -1) {
          step.fileList.splice(index, 1)
        }
      },
      getLastBatchCode() {
        this.uploadData.batch = this.Utils.df(null, '{y}{m}001')
        getLastBatch({
          client_id: parseInt(this.uploadData.client_id)
        }).then(resp => {
          let batch = resp.obj
          if (this.Utils.df(null, '{y}{m}') === batch.substring(0, 4)) {
            let prefix = batch.substring(0, 4)
            let code = parseInt(batch.substring(4))
            this.uploadData.batch = prefix + this.Utils.prefixInteger(code + 1, 3)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/upload.vue